import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { APIEditAudio } from '../../helper/APIFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic } from '@fortawesome/free-solid-svg-icons';

const AudioModal = ({ show, onHide, vis, isOrg, onVisEdit }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);
  const [audioFile, setAudioFile] = useState(null);
  const [autoplay, setAutoplay] = useState(vis.autoplay_audio || false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 4 * 1024 * 1024) {
      setError("File size cannot exceed 4MB.");
      setAudioFile(null);
    } else {
      setError(null);
      setAudioFile(file);
    }
  };

  const handleSave = () => {
    if (!audioFile && !vis.audio_url) {
      setError("Please select an audio file to upload.");
      return;
    }
    
    setIsUploading(true);
    setError(null);

    const reader = new FileReader();
    reader.onload = (event) => {
      const audioData = event.target.result;
      APIEditAudio(
        vis, 
        audioData, 
        autoplay,
        (updatedVis) => {
            setIsUploading(false);
            onVisEdit(updatedVis);
            onHide();
        },
        (err) => {
            setIsUploading(false);
            setError(err.message || "Failed to upload audio.");
        },
        {is_org: isOrg}
      );
    };
    reader.onerror = () => {
        setIsUploading(false);
        setError("Failed to read the audio file.");
    };

    if (audioFile) {
        reader.readAsDataURL(audioFile);
    } else {
        // This case handles saving autoplay change without new file
        APIEditAudio(vis, null, autoplay, (updatedVis) => {
            setIsUploading(false);
            onVisEdit(updatedVis);
            onHide();
        }, (err) => {
            setIsUploading(false);
            setError(err.message || "Failed to update audio settings.");
        }, {is_org: isOrg});
    }
  };
  
  const handleRemove = () => {
      setIsUploading(true);
      setError(null);
      APIEditAudio(vis, "", false, (updatedVis) => {
          setIsUploading(false);
          onVisEdit(updatedVis);
          onHide();
      }, (err) => {
          setIsUploading(false);
          setError(err.message || "Failed to remove audio.");
      }, {is_org: isOrg, remove: true});
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
            <FontAwesomeIcon icon={faMusic} className="me-2" />
            Add/Replace Audio
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <p className="text-danger">{error}</p>}
        
        <p>Upload an MP3 audio file that will play when the visual loads. Max file size: 4MB.</p>
        
        {vis.audio_url && (
            <div className="mb-3">
                <p>Current audio:</p>
                <audio controls src={vis.audio_url} style={{width: "100%"}}>
                    Your browser does not support the audio element.
                </audio>
            </div>
        )}

        <input type="file" accept=".mp3" onChange={handleFileChange} className="form-control mb-3" />

        <div className="form-check">
            <input 
                type="checkbox"
                className="form-check-input"
                id="autoplay-check"
                checked={autoplay}
                onChange={(e) => setAutoplay(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="autoplay-check">
                Autoplay audio
            </label>
        </div>

      </Modal.Body>
      <Modal.Footer>
        {vis.audio_url &&
            <Button variant="outline-danger" onClick={handleRemove} disabled={isUploading}>
                Remove Audio
            </Button>
        }
        <Button variant="secondary" onClick={onHide} disabled={isUploading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={isUploading || (!audioFile && vis.autoplay_audio === autoplay)}>
            {isUploading ? 'Saving...' : 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AudioModal; 